import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/context/store";
import { getCounterList, getDivisionList, getOrders, getProducts, getStateList, getStockists } from "src/services/po-api";
import { poActions } from "src/context/po-slice";
import { getLast30DaysISORange } from "src/utils/utils";

import { KAM_MODULE_CODE, SO_TYPE_SAO_CN } from "./po.constants";

export function usePoHandlers() {
    const dispatch = useDispatch();
    const { poFilters, poFiltersData } = useSelector((state: RootState) => state.po);

    const fetchStockist = async (value: any) => {
        const payload = {
            company_code: poFilters?.company?.code,
            counter_codes: poFilters?.counters?.map((item: any) => item?.counter_code)?.join(","),
            order_ids: poFilters?.orders?.map((item: any) => item?.order_id_int)?.join(","),
            state_codes: poFilters?.state?.map((item: any) => item?.state_code)?.join(","),
            division_codes: poFilters?.division?.map((item: any) => item?.company_divisioncode)?.join(","),
            item_codes: poFilters?.products?.map((item: any) => item?.item_code)?.join(","),
            module_code: poFilters?.module?.module_code,
            search: value,
        };

        try {
            const res = await getStockists(payload);
            dispatch(poActions.setPoFiltersData({ key: "stockist", value: res?.data?.data }));
            return res?.data?.data;
        } catch (error) {
            console.log(error);
        }
    };

    const fetchOrders = async (value: any) => {

        const payload = {
            company_code: poFilters?.company?.code,
            counter_codes: poFilters?.counters?.map((item: any) => item?.counter_code)?.join(","),
            order_ids: poFilters?.orders?.map((item: any) => item?.order_id_int)?.join(","),
            state_codes: poFilters?.state?.map((item: any) => item?.state_code)?.join(","),
            division_codes: poFilters?.division?.map((item: any) => item?.company_divisioncode)?.join(","),
            item_codes: poFilters?.products?.map((item: any) => item?.item_code)?.join(","),
            stockist_ids: poFilters?.stockist?.map((item: any) => item?.stockist_id)?.join(","),
            order_type: poFilters?.soType?.code,    //M10-12019
            module_code: poFilters?.module?.module_code,
            search: value,
        };

        try {
            const res = await getOrders(payload);
            dispatch(poActions.setPoFiltersData({ key: "orders", value: res?.data?.data }));
            return res?.data?.data;
        } catch (error) {
            console.log(error);
        }
    };

    const fetchState = async () => {

        try {
            const res = await getStateList();
            dispatch(poActions.setPoFiltersData({ key: "state", value: res?.data?.data }));
            return res?.data?.data;
        } catch (error) {
            console.log(error);
        }
    };

    const fetchDivision = async (value: any) => {
        const payload = {
            company_code: poFilters?.company?.code,
            search: value,
        };

        try {
            const res = await getDivisionList(payload);
            dispatch(poActions.setPoFiltersData({ key: "division", value: res?.data?.data }));
            return res?.data?.data;
        } catch (error) {
            console.log(error);
        }
    }

    const fetchProduct = async (value: any) => {
        const payload = {
            company_code: poFilters?.company?.code,
            counter_codes: poFilters?.counters?.map((item: any) => item?.counter_code)?.join(","),
            order_ids: poFilters?.orders?.map((item: any) => item?.order_id_int)?.join(","),
            state_codes: poFilters?.state?.map((item: any) => item?.state_code)?.join(","),
            division_codes: poFilters?.division?.map((item: any) => item?.company_divisioncode)?.join(","),
            item_codes: poFilters?.products?.map((item: any) => item?.item_code)?.join(","),
            stockist_ids: poFilters?.stockist?.map((item: any) => item?.stockist_id)?.join(","),
            search: value,
            order_type: poFilters?.soType?.code,    //M10-12019
            module_code: poFilters?.module?.module_code,
        };

        try {
            const res = await getProducts(payload);
            dispatch(poActions.setPoFiltersData({ key: "products", value: res?.data?.data }));
            return res?.data?.data;
        } catch (error) {
            console.log(error);
        }
    }

    const fetchCounter = async (value: any) => {
        const payload = {
            company_code: poFilters?.company?.code,
            counter_codes: poFilters?.counters?.map((item: any) => item?.counter_code)?.join(","),
            order_ids: poFilters?.orders?.map((item: any) => item?.order_id_int)?.join(","),
            state_codes: poFilters?.state?.map((item: any) => item?.state_code)?.join(","),
            division_codes: poFilters?.division?.map((item: any) => item?.company_divisioncode)?.join(","),
            item_codes: poFilters?.products?.map((item: any) => item?.item_code)?.join(","),
            stockist_ids: poFilters?.stockist?.map((item: any) => item?.stockist_id)?.join(","),
            module_code: poFilters?.module?.module_code,
            search: value,
        };

        try {
            const res = await getCounterList(payload);
            dispatch(poActions.setPoFiltersData({ key: "counters", value: res?.data?.data }));
            return res?.data?.data;
        } catch (error) {
            console.log(error);
        }
    }

    const handleResetFilters = () => {
        dispatch(poActions.setPoFilters({ key: "company", value: null }));
        dispatch(poActions.setPoFilters({ key: "soType", value: null }));
        dispatch(poActions.setPoFilters({ key: "state", value: null }));
        dispatch(poActions.setPoFilters({ key: "stockist", value: null }));
        dispatch(poActions.setPoFilters({ key: "orders", value: null }));
        dispatch(poActions.setPoFilters({ key: "division", value: null }));
        dispatch(poActions.setPoFilters({ key: "products", value: null }));
        dispatch(poActions.setPoFilters({ key: "counters", value: null }));
        dispatch(poActions.setPoFilters({ key: "dateRange", value: getLast30DaysISORange() }));
        //M10-12019
        dispatch(poActions.setPoFilters({ key: "orderDate", value: null }));
        dispatch(poActions.setPoFilters({ key: "fileUploadDate", value: null }));
        //M10-12019
        dispatch(poActions.setPoFilters({ key: "invoiceDate", value: null }));  //M10-13833
        dispatch(poActions.setPoFilters({ key: "module", value: poFiltersData?.module?.find((item: any) => item?.module_code === 1) ?? null }));
        dispatch(poActions.setPoFiltersData({ key: "stockist", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "division", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "products", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "counters", value: null }));
    };
    //M10-12019
    const companyHandler = (value: any) => {
        dispatch(poActions.setPoFilters({ key: "stockist", value: null }));
        dispatch(poActions.setPoFilters({ key: "orders", value: null }));
        dispatch(poActions.setPoFilters({ key: "division", value: null }));
        dispatch(poActions.setPoFilters({ key: "products", value: null }));
        dispatch(poActions.setPoFilters({ key: "counters", value: null }));
        dispatch(poActions.setPoFilters({ key: "soType", value: null }));
        dispatch(poActions.setPoFilters({ key: "company", value: value }));
        dispatch(poActions.setPoFilters({ key: "orderDate", value: null }));
        dispatch(poActions.setPoFilters({ key: "fileUploadDate", value: null }));
        dispatch(poActions.setPoFilters({ key: "invoiceDate", value: null }));  //M10-13833
        dispatch(poActions.setPoFiltersData({ key: "stockist", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "division", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "products", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "counters", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "soType", value: null }));

    }
    const soTypeHandler = (value: any) => {
        dispatch(poActions.setPoFilters({ key: "stockist", value: null }));
        dispatch(poActions.setPoFilters({ key: "orders", value: null }));
        dispatch(poActions.setPoFilters({ key: "division", value: null }));
        dispatch(poActions.setPoFilters({ key: "products", value: null }));
        dispatch(poActions.setPoFilters({ key: "counters", value: null }));
        dispatch(poActions.setPoFilters({ key: "soType", value: value }))
        dispatch(poActions.setPoFiltersData({ key: "stockist", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "division", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "products", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "counters", value: null }));
    }
    const moduleHandler = (value: any) => {
        dispatch(poActions.setPoFilters({ key: "stockist", value: null }));
        dispatch(poActions.setPoFilters({ key: "orders", value: null }));
        dispatch(poActions.setPoFilters({ key: "division", value: null }));
        dispatch(poActions.setPoFilters({ key: "products", value: null }));
        dispatch(poActions.setPoFilters({ key: "counters", value: null }));
        dispatch(poActions.setPoFilters({ key: "module", value: value }));
        dispatch(poActions.setPoFiltersData({ key: "stockist", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "division", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "products", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "counters", value: null }));
        // SAO-CN only exists for KAM (module 4) — drop the selection when moving off KAM so the
        // generate call can't be fired with a combination the backend rejects.
        if (Number(value?.module_code) !== KAM_MODULE_CODE && poFilters?.soType?.code === SO_TYPE_SAO_CN) {
            dispatch(poActions.setPoFilters({ key: "soType", value: null }));
        }
    }
    const orderDateHandler = (value: any) => {
        dispatch(poActions.setPoFilters({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "orders", value: null }));
        dispatch(poActions.setPoFilters({ key: "orderDate", value: new Date(value)?.toISOString() }))
    }
    const fileUploadDateHandler = (value: any) => {
        dispatch(poActions.setPoFilters({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "orders", value: null }));
        dispatch(poActions.setPoFilters({ key: "fileUploadDate", value: new Date(value)?.toISOString() }))
    }
    //M10-13833
    const invoiceDateHandler = (value: any) => {
        dispatch(poActions.setPoFilters({ key: "invoiceDate", value: value || null }))
    }
    //M10-13833
    //M10-12019
    const stateHandler = (value: any, action: string) => {
        dispatch(poActions.setPoFilters({ key: "stockist", value: null }));
        dispatch(poActions.setPoFilters({ key: "orders", value: null }));
        dispatch(poActions.setPoFilters({ key: "division", value: null }));
        dispatch(poActions.setPoFilters({ key: "products", value: null }));
        dispatch(poActions.setPoFilters({ key: "counters", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "stockist", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "division", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "products", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "counters", value: null }));
        const existingStates = poFilters?.state || [];
        let updatedStates;

        if (action === "add") {
            const isAlreadyPresent = existingStates.some(
                (item: any) => item?.state_code === value?.state_code
            );
            updatedStates = isAlreadyPresent
                ? existingStates
                : [...existingStates, value];
        } else if (action === "remove") {
            updatedStates = existingStates.filter(
                (item: any) => item?.state_code !== value?.state_code
            );
        } else if (action === "bulk-add") {
            // Merge and deduplicate by state_code
            const all = [...existingStates, ...value];
            updatedStates = Array.from(
                new Map(all.map((item: any) => [item.state_code, item])).values()
            );
        } else if (action === "bulk-remove") {
            const idsToRemove = value.map((v: any) => v.state_code);
            updatedStates = existingStates.filter(
                (item: any) => !idsToRemove.includes(item.state_code)
            );
        } else {
            updatedStates = value;
        }

        dispatch(poActions.setPoFilters({ key: "state", value: updatedStates }));
    };

    const stockistHandler = (value: any, action: string) => {
        dispatch(poActions.setPoFilters({ key: "orders", value: null }));
        dispatch(poActions.setPoFilters({ key: "division", value: null }));
        dispatch(poActions.setPoFilters({ key: "products", value: null }));
        dispatch(poActions.setPoFilters({ key: "counters", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "division", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "products", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "counters", value: null }));
        const existingCompanies = poFilters?.stockist || []; // Get current array from Redux

        let updatedCompanies;

        if (action === "add") {
            // Add only if not already present (based on uniqueKey 'code')
            const isAlreadyPresent = existingCompanies.some((item: any) => item?.company_stockist_code === value?.company_stockist_code);
            if (!isAlreadyPresent) {
                updatedCompanies = [...existingCompanies, value];
            } else {
                updatedCompanies = existingCompanies;
            }
        } else if (action === "remove") {
            // Remove company by filtering out the one with matching code
            updatedCompanies = existingCompanies.filter((item: any) => item?.company_stockist_code !== value?.company_stockist_code);
        } else if (action === "bulk-add") {
            // Merge and deduplicate by company_stockist_code
            const all = [...existingCompanies, ...value];
            updatedCompanies = Array.from(
                new Map(all.map((item: any) => [item.company_stockist_code, item])).values()
            );
        } else if (action === "bulk-remove") {
            const idsToRemove = value.map((v: any) => v.company_stockist_code);
            updatedCompanies = existingCompanies.filter(
                (item: any) => !idsToRemove.includes(item.company_stockist_code)
            );
        } else {
            // Fallback: overwrite with the provided value (array)
            updatedCompanies = value;
        }

        dispatch(poActions.setPoFilters({ key: "stockist", value: updatedCompanies }));
    };

    const orderHandler = (value: any, action: string) => {
        dispatch(poActions.setPoFilters({ key: "products", value: null }));
        dispatch(poActions.setPoFilters({ key: "counters", value: null }));
        dispatch(poActions.setPoFilters({ key: "orderDate", value: null }));
        dispatch(poActions.setPoFilters({ key: "fileUploadDate", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "products", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "counters", value: null }));
        const existingCompanies = poFilters?.orders || []; // Get current array from Redux

        let updatedCompanies;

        if (action === "add") {
            // Add only if not already present (based on uniqueKey 'code')
            const isAlreadyPresent = existingCompanies.some((item: any) => item?.order_id_int === value?.order_id_int);
            if (!isAlreadyPresent) {
                updatedCompanies = [...existingCompanies, value];
            } else {
                updatedCompanies = existingCompanies;
            }
        } else if (action === "remove") {
            // Remove company by filtering out the one with matching code
            updatedCompanies = existingCompanies.filter((item: any) => item?.order_id_int !== value?.order_id_int);
        } else if (action === "bulk-add") {
            // Merge and deduplicate by company_stockist_code
            const all = [...existingCompanies, ...value];
            updatedCompanies = Array.from(
                new Map(all.map((item: any) => [item.order_id_int, item])).values()
            );
        } else if (action === "bulk-remove") {
            const idsToRemove = value.map((v: any) => v.order_id_int);
            updatedCompanies = existingCompanies.filter(
                (item: any) => !idsToRemove.includes(item.order_id_int)
            );
        } else {
            // Fallback: overwrite with the provided value (array)
            updatedCompanies = value;
        }

        dispatch(poActions.setPoFilters({ key: "orders", value: updatedCompanies }));
    };
    const divisionHandler = (value: any, action: string) => {
        dispatch(poActions.setPoFilters({ key: "products", value: null }));
        dispatch(poActions.setPoFilters({ key: "counters", value: null }));
        dispatch(poActions.setPoFilters({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "orders", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "products", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "counters", value: null }));
        const existingCompanies = poFilters?.division || []; // Get current array from Redux

        let updatedCompanies;

        if (action === "add") {
            // Add only if not already present (based on uniqueKey 'code')
            const isAlreadyPresent = existingCompanies.some((item: any) => item?.company_divisioncode === value?.company_divisioncode);
            if (!isAlreadyPresent) {
                updatedCompanies = [...existingCompanies, value];
            } else {
                updatedCompanies = existingCompanies;
            }
        } else if (action === "remove") {
            // Remove company by filtering out the one with matching code
            updatedCompanies = existingCompanies.filter((item: any) => item?.company_divisioncode !== value?.company_divisioncode);
        } else if (action === "bulk-add") {
            // Merge and deduplicate by company_stockist_code
            const all = [...existingCompanies, ...value];
            updatedCompanies = Array.from(
                new Map(all.map((item: any) => [item.company_divisioncode, item])).values()
            );
        } else if (action === "bulk-remove") {
            const idsToRemove = value.map((v: any) => v.company_divisioncode);
            updatedCompanies = existingCompanies.filter(
                (item: any) => !idsToRemove.includes(item.company_divisioncode)
            );
        } else {
            // Fallback: overwrite with the provided value (array)
            updatedCompanies = value;
        }

        dispatch(poActions.setPoFilters({ key: "division", value: updatedCompanies }));
    };
    const productHandler = (value: any, action: string) => {
        dispatch(poActions.setPoFilters({ key: "counters", value: null }));
        dispatch(poActions.setPoFiltersData({ key: "counters", value: null }));
        const existingCompanies = poFilters?.products || []; // Get current array from Redux

        let updatedCompanies;

        if (action === "add") {
            // Add only if not already present (based on uniqueKey 'code')
            const isAlreadyPresent = existingCompanies.some((item: any) => item?.item_code === value?.item_code);
            if (!isAlreadyPresent) {
                updatedCompanies = [...existingCompanies, value];
            } else {
                updatedCompanies = existingCompanies;
            }
        } else if (action === "remove") {
            // Remove company by filtering out the one with matching code
            updatedCompanies = existingCompanies.filter((item: any) => item?.item_code !== value?.item_code);
        } else if (action === "bulk-add") {
            // Merge and deduplicate by company_stockist_code
            const all = [...existingCompanies, ...value];
            updatedCompanies = Array.from(
                new Map(all.map((item: any) => [item.item_code, item])).values()
            );
        } else if (action === "bulk-remove") {
            const idsToRemove = value.map((v: any) => v.item_code);
            updatedCompanies = existingCompanies.filter(
                (item: any) => !idsToRemove.includes(item.item_code)
            );
        } else {
            // Fallback: overwrite with the provided value (array)
            updatedCompanies = value;
        }

        dispatch(poActions.setPoFilters({ key: "products", value: updatedCompanies }));
    };

    const counterHandler = (value: any, action: string) => {
        const existingCompanies = poFilters?.counters || []; // Get current array from Redux

        let updatedCompanies;

        if (action === "add") {
            // Add only if not already present (based on uniqueKey 'code')
            const isAlreadyPresent = existingCompanies.some((item: any) => item?.counter_code === value?.counter_code);
            if (!isAlreadyPresent) {
                updatedCompanies = [...existingCompanies, value];
            } else {
                updatedCompanies = existingCompanies;
            }
        } else if (action === "remove") {
            // Remove company by filtering out the one with matching code
            updatedCompanies = existingCompanies.filter((item: any) => item?.counter_code !== value?.counter_code);
        } else if (action === "bulk-add") {
            // Merge and deduplicate by company_stockist_code
            const all = [...existingCompanies, ...value];
            updatedCompanies = Array.from(
                new Map(all.map((item: any) => [item.counter_code, item])).values()
            );
        } else if (action === "bulk-remove") {
            const idsToRemove = value.map((v: any) => v.counter_code);
            updatedCompanies = existingCompanies.filter(
                (item: any) => !idsToRemove.includes(item.counter_code)
            );
        } else {
            // Fallback: overwrite with the provided value (array)
            updatedCompanies = value;
        }

        dispatch(poActions.setPoFilters({ key: "counters", value: updatedCompanies }));
    };

    return {
        fetchStockist,
        fetchOrders,
        fetchState,
        fetchDivision,
        fetchProduct,
        fetchCounter,
        handleResetFilters,
        companyHandler,
        stateHandler,
        stockistHandler,
        orderHandler,
        divisionHandler,
        productHandler,
        counterHandler,
        //M10-12019
        soTypeHandler,
        moduleHandler,
        orderDateHandler,
        fileUploadDateHandler,
        invoiceDateHandler  //M10-13833
        //M10-12019
    };
}
